// extracted by mini-css-extract-plugin
export default {"layoutPage":"wrapper-mobile-page_layoutPage__hC6NQ","contentSection":"wrapper-mobile-page_contentSection__A5qAW"};